import React from 'react';
import {
  DashboardOutlined,
  UserOutlined,
  GiftOutlined,
  QuestionCircleOutlined,
  QrcodeOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';

export interface NavigationItem {
  key: string;
  icon: React.ReactElement;
  label: string;
  roles?: string[];
  children?: NavigationItem[];
}

// Navigation items configuration
export const navigationItems: MenuProps['items'] = [
  {
    key: '/',
    icon: React.createElement(DashboardOutlined),
    label: 'Dashboard',
  },
  {
    key: '/users',
    icon: React.createElement(UserOutlined),
    label: 'User Management',
  },
  {
    key: '/events',
    icon: React.createElement(QrcodeOutlined),
    label: 'Event Management',
  },
  {
    key: '/quizzes',
    icon: React.createElement(QuestionCircleOutlined),
    label: 'Mini Quiz',
  },
  {
    key: '/vouchers',
    icon: React.createElement(GiftOutlined),
    label: 'Vouchers',
  },
];

// Role-based navigation filter
export const getNavigationByRole = (userRole: string): MenuProps['items'] => {
  // For now, admin users can see all items
  // This can be extended to filter based on roles
  switch (userRole) {
    case 'admin':
      return navigationItems;
    case 'moderator':
      return navigationItems?.filter(item => 
        item && typeof item === 'object' && 'key' in item && 
        !['settings', 'security'].includes(item.key as string)
      );
    default:
      return navigationItems?.slice(0, 3); // Only basic items for other roles
  }
};
